import { ErrorHandler } from '@angular/core';
import { InjectorModule } from './shared/modules/injector.module';
import { BuildInfoCheckService } from './shared/services/build-info-check.service';
import { DatadogRumService } from './shared/services/datadog.service';

export class GlobalErrorHandler implements ErrorHandler {
  constructor() {}

  handleError(e: unknown) {
    console.error(e);
    const dataDogRumService = InjectorModule.injector.get(DatadogRumService);
    const buildInfoCheckService = InjectorModule.injector.get(BuildInfoCheckService);

    if (this.isChunkFailedError(e)) {
      buildInfoCheckService.openDialog('');
    } else {
      dataDogRumService.rum.addError(e);
    }
  }

  private isChunkFailedError(err: any) {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    return chunkFailedMessage.test(err.message);
  }
}
